import {remCalc} from '_themeUtils'

const productColorSelector = {
    ProductColorSelector: {
        baseStyle: ({moreColor}) => ({
            // ─── Drawer content ───────────────────────────────────────────
            container: {
                gap: 'spacing.10',
            },
            drawerTitle: {
                textTransform: 'none',
                textStyle: 'displayXs',
                fontWeight: 500,

                _firstLetter: {
                    textTransform: 'capitalize',
                },
            },
            colorsWrapper: {
                w: '100%',
                gap: {base: '0', md: '0.5rem'},
            },
            colorItemWrapper: {
                w: '100%',
                justifyContent: 'space-between',
                _hover: {
                    bg: 'color.background.grey.200',
                },
            },
            colorItemButton: {
                w: 'auto',
                flex: '1 1',
                textAlign: 'left',
                borderBottom: '1px solid',
                borderColor: 'color.border.grey.300',
                _hover: {
                    borderBottom: '1px solid black',
                },
            },
            colorItemButtonSelected: {
                pointerEvents: 'none',
            },
            colorItemLabel: {
                w: '100%',
                textStyle: 'paragraphSm',
                fontWeight: 'normal',
            },

            // ─── Inline swatches row (PDP) ────────────────────────────────
            swatchesRow: {
                w: '100%',
                justifyContent: 'space-between',
                alignItems: 'center',
                py: moreColor ? 0 : remCalc(15),
            },
            swatchesLabel: {
                textStyle: 'paragraphSm',
                fontWeight: 'normal',
                flexShrink: 0,
            },
            swatchesList: {
                gap: 'spacing.3',
                alignItems: 'center',
            },
            // Figma "Color dots" outer box (24px). Two-ring visual (inner dark dot + grey outer ring
            // on selection) is handled by the ColorCircle atom via its `selected` prop.
            swatchItem: {
                position: 'relative',
                w: remCalc(24),
                h: remCalc(24),
                flexShrink: 0,
                p: 0,
            },
            swatchMoreCta: {
                textStyle: 'paragraphXs',
                fontWeight: 400,
                whiteSpace: 'nowrap',
            },
        }),
    },
}

export default productColorSelector
